var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue } from 'vue-property-decorator';
import PageHeader from '@/components/page-header/PageHeader';
import { School } from '@/models/School';
let Roster = class Roster extends Vue {
    constructor() {
        super(...arguments);
        this.activeTab = '/roster';
        this.isLoading = true;
    }
    mounted() {
        this.isLoading = false;
        this.$pageTitle = this.$t('roster.settings').toString();
    }
};
__decorate([
    Prop({ default: () => new School() }),
    __metadata("design:type", typeof (_a = typeof School !== "undefined" && School) === "function" ? _a : Object)
], Roster.prototype, "school", void 0);
Roster = __decorate([
    Component({
        components: {
            PageHeader,
        },
    })
], Roster);
export default Roster;
